var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lastStats(_vm.prefix.id))?[_c('h2',[_vm._v("Hit Rates")]),_c('BaseCard',{staticClass:"card-top",attrs:{"grow":true}},[_c('BaseStats',{attrs:{"stats":[
          {
            value: _vm.getValByMetric('hit_rate', _vm.unit.PERCENT),
            label: _vm.metricLabel('hit_rate'),
          },
          {
            value: _vm.getValByMetric('prefix_hit_rate', _vm.unit.PERCENT),
            label: _vm.metricLabel('prefix_hit_rate'),
            icon: 'question-circle',
            iconToolTip: _vm.hrStatus.message,
            iconIssueType: _vm.hrStatus.type,
          } ]}})],1),_c('h2',[_vm._v("Prefix Weight")]),_c('BaseCard',{attrs:{"grow":true}},[_c('BaseStats',{attrs:{"stats":[
          {
            value: _vm.getValByMetric('prefix_over_compound_requests', _vm.unit.PERCENT),
            label: _vm.metricLabel('prefix_over_compound_requests'),
            icon: 'question-circle',
            iconToolTip: _vm.helpPrefixFractionRequests,
          },
          {
            value: _vm.getValByMetric('prefix_over_compound_num_keys', _vm.unit.PERCENT),
            label: _vm.metricLabel('prefix_over_compound_num_keys'),
            icon: 'question-circle',
            iconToolTip: _vm.helpPrefixFractionItems,
          },
          {
            value: _vm.getValByMetric('prefix_over_compound_total_size', _vm.unit.PERCENT),
            label: _vm.metricLabel('prefix_over_compound_total_size'),
            icon: 'question-circle',
            iconToolTip: _vm.helpPrefixFractionMemory,
          } ]}})],1),_c('h2',[_vm._v("Prefix Activity")]),_c('BaseCard',{attrs:{"grow":true}},[_c('BaseStats',{attrs:{"stats":[
          {
            value: _vm.getValByMetric('prefix_total_hits_rate', _vm.unit.PER_SECOND),
            label: _vm.metricLabel('prefix_total_hits_rate'),
            small: true,
          },
          {
            value: _vm.getValByMetric('prefix_total_misses_rate', _vm.unit.PER_SECOND),
            label: _vm.metricLabel('prefix_total_misses_rate'),
            small: true,
          },
          {
            value: _vm.getValByMetric('prefix_total_mutations_rate', _vm.unit.PER_SECOND),
            label: _vm.metricLabel('prefix_total_mutations_rate'),
            small: true,
          } ]}}),(_vm.issue('activity').message)?_c('BaseNotice',{staticClass:"notice",attrs:{"type":_vm.issue('activity').type}},[_vm._v(" "+_vm._s(_vm.issue("activity").message)+" ")]):_vm._e()],1)]:_c('BaseLoading')],2)}
var staticRenderFns = []

export { render, staticRenderFns }